<div>
    <img style="height: 80px; cursor: pointer" [src]="editData" (click)="clearTmpImg()">
    <div class="btn btn-info" style="position: relative; margin-left: 10px;">
        <input style="opacity: 0; width: 100%; height: 100%; position: absolute; left: 0; top: 0;" type="file" placeholder="Upload file" (change)="upload($event, '0')" accept=".jpeg, .jpg, .png, .gif">
        點我上傳
    </div>
</div>

